export default {
  //导航
  导航: {
    联系我们: {
      总部: "总部：",
      生产制造: "生产制造：",
      研发中心: "研发中心：",
      常州: "常州",
      长春: "长春",
      上海: "上海",
      惠州: "惠州",
      武汉: "武汉",
      武汉车联网研发分公司: "武汉车联网研发分公司",
      长春车身电子生产基地: "长春车身电子生产基地",
      常州富晟智能网联总部: "常州富晟智能网联总部",
      上海车联网研发中心: "上海车联网研发中心",
      惠州车身电子研发中心: "惠州车身电子研发中心",
      联系我们: "联系我们",
      电话: "电话：0510-66600888",
      常州总部:
        "常州总部：江苏省常州市经开区潞城街道东关路1668号东方汽车电子产业园7号",
      邮箱: "邮箱：contact@fawsn-ae.com",
      长春基地: "长春基地：吉林省长春市高新区超强街4777号富晟智能制造产业园",
    },
    产品服务: {
      产品服务: "产品服务",
      车身电子: "车身电子",
      车身电子desc:
        "车门控制器、座椅控制器、天窗控制器、车内氛围灯电路、尾灯控制电路板、车外Logo灯等电路板",
      智能座舱: "智能座舱",
      智能座舱desc: "座舱域控制器、T-Box、电子外后视镜(CMS)、功放、扬声器",
      智能驾驶: "智能驾驶",
      智能驾驶desc: "智能前视摄像头、毫米波雷达、智能驾驶域控制器",
      车联网: "车联网",
      车联网desc: "OTA、远程诊断(RDS)、以太网协议栈、自适应AutoSAR",
    },
    首页: {
      首页: "首页",
      产品中心: {
        产品中心: "产品中心",
      },
      生产和开发服务: {
        生产和开发服务: "生产和开发服务",
        服务范围: "服务范围：",
        服务特点: "服务特点：",
        服务范围11:
          "（1）机电类控制器开发。如车门控制器、天窗控制器、空调出风口控制器、座椅按摩控制器等",
        服务范围12:
          "（2）光电控制系统开发，如氛围灯控制板、尾灯控制板、前照灯控制器、旗标灯控制板等",
        服务范围13: "（3）复杂SoC产品的开发，如智驾和座舱的域控制器开发等",
        服务特点1: "AutoSAR、功能安全、信息安全、复杂电磁环境兼容等",
        服务范围21: "（1）多层板SMT贴片",
        服务范围22: "（2）选择焊、回流焊等",
        服务范围23: "（3）总成组装、测试",
        服务特点2: "质量保证、标准符合",
      },
      邮箱: "邮箱",
      电话: "电话",
    },
    关于富晟智能网联: {
      年: "年",
      关于富晟智能网联: "   关于FSICV   ",
      公司概述: "公司概述",
      发展历程: "发展历程",
      公司成立:"公司成立",
      苏州生产基地建成:"苏州生产基地建成",
      域控产品出货10w套:"域控产品出货10w套",
      欧洲研发中心成立:"欧洲研发中心成立",
      香港交易所主板上市:"香港交易所主板上市",
      国产芯方案量产:"国产芯方案量产",
      总部大楼落成:"总部大楼落成",
      发展历程列表: {
        2018: {
          1: "广东总公司惠州中心成立",
        },
        2019: {
          1: "十万级洁净厂房启用首条产品线调试完成",
          2: "奔腾首个项目定点",
          3: "红旗2个项目定点",
        },
        2020: {
          1: ' <text style="font-weight: 600;">长春中心成立</text>',
          2: "红旗1个定点项目",
          3: "IATF 16949资质认证",
        },
        2021: {
          1: "通过长城潜在供应商审核并获得项目定点",
          2: "通过吉利潜在供应商审核",
          3: "通过北汽新能源潜在供应商审核",
          4: "红旗电子后视镜预研项目",
        },
        2022: {
          1: "长城3个项目定点",
          2: "红旗2个项目定点",
        },
        2023: {
          1: "红旗2个AR光影项目定点",
          2: "通过吉利车灯潜在供应商审核",
          3: "通过大众精品组潜在供应商审核",
          4: "通过ASPICE L2级认证",
          5: "通过解放潜在供应商审核",
          6: "大运座椅控制器项目定点",
          7: "红旗车灯控制板项目定点",
        },
        2024: {
          1: "事业部总部落地常州",
          2: "大众AR光影尾门产品定点",
          3: "通过宇通潜在供应商审核",
          4: "通过犀重供应商审核",
        },
      },
      资质荣誉: "资质荣誉",
      企业文化: "企业文化",
      关于富晟: "关于富晟",
      联系我们: "联系我们",
      资质证书: "资质证书",
      专利证书: "专利证书",
      主要客户: "主要客户",
      核心产品与技术: "核心产品与技术",
      智能网联事业部: "智能网联事业部",
      富晟集团: "富晟集团",
      富晟智能网联事业部: "富晟智能网联事业部",
      公司隶属:
        "公司隶属：长春富晟集团有限公司（中国一汽战略核心供应商之一）的全资子公司",
      业务领域:
        "业务领域：汽车电子产品研发、生产、销售与售后服务于一体，涵盖车身电子、智能驾驶、智能座舱、车联网四大板块",
      研发中心: "研发中心：常州、长春、上海、惠州、武汉",
      生产布局: "生产布局：常州、长春",
      资质体系:
        "资质体系：IATF16949、ISO14001、ISO26262、实验室CNAS认证、软件资质ASPICE L2",
      公司主楼照片: "公司主楼照片",
      使命: "使命",
      使命desc: "科技引领未来，持续创造价值，推动社会进步",
      愿景: "愿景",
      愿景desc: "打造可持续发展的科技型综合事业平台",
      核心价值观: "核心价值观",
      核心价值观desc: "诚信尊重、激情高效、务实创新、奋斗共赢",
      经营方针: "经营方针",
      经营方针desc: "满足客户需求，并持续为客户创造价值",
      品牌: "品牌",
      品牌desc: "诚信凝聚力量，创新铸就未来",
    },
    产品中心: {
      产品功能: "产品功能：",
      产品特点: "产品特点：",
      产品中心: "产品中心",
      车身产品线: "车身产品线",
      智能座舱产品线: "智能座舱产品线",
      智能座舱产品线列表: {
        1: {
          name: "车载功放（及扬声器）",
          gongneng:
            "对前级音源的微弱音频信号进行放大，提供足够的功率和动态范围，使音乐更加真实、清晰、细腻，并提供较好的低音效果，让乘员享受更加震撼的音乐效果",
          tedian: "失真抑制、算法优异、高效能、扩展性强",
        },
        2: {
          name: "座舱域控制器",
          gongneng:
            "实现信息娱乐系统、行车电脑数据的显示与处理、空调控制、驾驶辅助系统等多系统的综合控制",
          tedian: "多模态交互、多连屏控制、个性化服务、国产化、集成化设计",
        },
        3: {
          name: "电子外后视镜（CMS）",
          gongneng:
            "通过摄像头与监视器的组合来取代传统的光学外后视镜, 减少视野盲区，提供全方位清晰视野，助力驾驶员安全驾驶",
          tedian: "国产化、低成本、定制化、功能安全、信息安全",
        },
        4: {
          name: "T-BOX",
          gongneng:
            "是车联网系统的核心组件，主要功能包括远程控制车辆（如启动发动机、开关门窗/空调）、联网通信（提供4G/Wi-Fi热点）、OTA升级、紧急救援服务（eCall）、实时车辆诊断与异常监控，以及GPS定位等‌",
          tedian: "低成本、金融服务支持、国产化、存储与通信安全",
        },
        5: {
          name: "驾驶员疲劳监测（DMS）",
          gongneng:
            "基于红外摄像头为传感器，支持疲劳监测、注意力识别等功能，当出现驾驶员疲劳或注意力不集中时，及时报警以降低道路交通事故风险",
          tedian:
            "满足功能安全ASIL-B、通过ENCAP法规认证、通过DDAW法规认证、支持L3自动驾驶",
        },
      },
      智能驾驶产品线: "智能驾驶产品线",
      智能驾驶产品线列表: {
        1: {
          name: "智能前视一体机",
          gongneng:
            "通过摄像头捕捉道路和周围环境的信息，实现车道保持辅助、行人检测、自动紧急刹车（AEB）和自适应巡航控制等功能",
          tedian: "高度集成化、低成本、国产化、多传感数据的融合、多系统联动",
        },
        2: {
          name: "行泊一体控制器",
          gongneng:
            "将智能驾驶与自动泊车功能集成的控制器，主要应用于 L2++ 或 L2.9 级别的自动驾驶系统中。通过将行车和泊车功能整合在一个域控制器上，实现了降本增效的效果，节省了硬件成本并提高了功能迭代的开发效率",
          tedian: "国产化、算法优异、低成本、多传感数据融合",
        },
        3: {
          name: "自动紧急制动系统（AEBS）",
          gongneng:
            "利用车辆传感器识别到前方有障碍物，如果驾驶员未采取有效的避障措施，系统会自动进行紧急制动，以避免或减少与障碍物的碰撞",
          tedian: "算法优异、国产化、低成本、集成度高、多传感器数据融合",
        },
      },
      车身电子产品线: "车身电子产品线",
      车身电子产品线列表: {
        1: {
          name: "车身域控制器",
          gongneng:
            "实现车门、车窗、舱内氛围灯、外部前照灯、电源分配和管理、通信等车身控制功能",
          tedian: "国产化、低成本、定制化、功能安全、信息安全",
        },
        2: {
          name: "座椅控制器",
          gongneng:
            "实现座椅位置、高度、靠背角度等基本调节功能，可支持加热、通风、按摩、记忆、安全联动（如与安全带预紧器协同）等多功能",
          tedian: "国产化、低成本、定制化、功能安全、信息安全",
        },
        3: {
          name: "座椅按摩控制器",
          gongneng:
            "通过控制电磁阀体通断来控制气囊充放气，模拟按摩动作。缓解长时间驾驶的疲劳感，提高驾驶专注度及乘坐舒适性",
          tedian: "国产化、低成本、定制化、功能安全、信息安全",
        },
        4: {
          name: "车门控制器",
          gongneng:
            "集成后视镜调节、门锁控制、灯具开关、车窗升降及防夹、隐藏式门把手和电动开闭等功能",
          tedian:
            "侧滑、剪刀、鹰翼等多模式、多功能集成设计、智能感应操作、车窗防夹保护、兼容性强",
        },
        5: {
          name: "天窗控制器",
          gongneng:
            "支持物理按键、遥控钥匙、虚拟按键及远程控制，具备锁车自动关闭天窗、感应雨量自动关闭及未关提醒等功能",
          tedian:
            "多种开闭控制方式、智能感应自动关闭、锁车自动关窗功能、未关提醒保障安全、国产化平台设计",
        },
        6: {
          name: "车内氛围灯控制板",
          gongneng:
            "通过RGB色彩模式实现丰富的色彩变化，可以安装在车门、中控台、脚踏板等多个位置，通过精准控制实现不同区域的独立照明和色彩调节‌",
          tedian: "舒适性、设计感与豪华感、个性化与科技感",
        },
        7: {
          name: "前照灯控制器",
          gongneng:
            "实现近光灯、远光灯、转向灯等功能。可根据客户需求，实现自适应远光灯照明（ADB）、自动转向（AFS）等功能",
          tedian: "低成本、国产化、算法成熟",
        },
        8: {
          name: "车尾灯控制器",
          gongneng:
            "全LED后组合灯集成位置灯、刹车灯、流水转向灯、倒车灯以及后雾灯等功能。可实现贯穿一体式厚壁件，让整个位置灯点亮后更加具有识别度及精致感",
          tedian: "全LED、国产化、低成本",
        },
        9: {
          name: "外部饰灯控制板",
          gongneng:
            "实现多颗LED顺序点亮，具有动态流水、渐变等点亮效果，增强车辆解、闭锁的仪式感",
          tedian: "低成本、国产化、平台化设计、恒流源驱动、亮度效果均匀",
        },
        10: {
          name: "智能尾门光影传感器",
          gongneng:
            "通过光影定位及红外检测或毫米波检测技术，当用户踩踏投影光标时，传感器进行逻辑检测，实现非接触式的尾门自动开启或关闭",
          tedian: "解放双手、操作简单、识别率高、误触率低、适应复杂环境",
        },
        11: {
          name: "车载无线充电模块",
          gongneng:
            "采用Qi标准，适用于多种智能设备快速充电。具备过热、过压保护机制，确保充电过程安全稳定",
          tedian:
            "输出功率15W/50W、可集成NFC数字钥匙功能、FOTA功能、Qi认证、国产化平台方案、低成本",
        },
        12: {
          name: "数字钥匙",
          gongneng: "可实现无钥匙进入和启动、远程监控和报警等功能",
          tedian: "边界的操作体验、车辆使用的多层备份、低成本、多功能扩展",
        },
      },
      车联网产品线: "车联网产品线",
      车联网产品线列表: {
        1: {
          name: "空中下载技术（OTA）",
          gongneng:
            "通过移动通信的接口实现对软件进行远程管理。与传统的4S店升级不同,OTA技术通过网络实现软件升级,大大提升了效率",
          tedian: "便捷性、实时性、安全性、个性化、成本效益",
        },
        2: {
          name: "以太网协议栈",
          gongneng:
            "涵盖 UDS、DOIP、SOME/IP、AVB/TSN、gPTP、RTP/RTCP 等关键协议，支持车载诊断、服务通信、时间同步、确定性传输、网络管理等功能，适用于智能网联汽车、工业自动化、车载网络等场景，具备高可靠性、低时延、多协议集成、灵活配置 等特点，满足复杂工业与汽车通信需求。",
          tedian: "高效性、实时性和稳定性",
        },
        3: {
          name: "eSync 3.0",
          gongneng:
            "eSync 平台是一个安全的车联网平台，采用服务器 - 客户端 - 代理架构，平台可以帮助车辆建立一套完整的车云双向高速数据管道，包括从云端到车端的 OTA 软件推送，以及从车端到云端的车辆诊断及数据收集等，覆盖不同类型的零件，不同的操作系统，以及不同车辆 EE 架构。",
          tedian: "国产化、低成本、定制化、功能安全、信息安全",
        },
        4: {
          name: "远程诊断（RDS）",
          gongneng:
            "通过互联网技术，利用车辆自检功能和网络通信技术，实现对车辆故障的远程排查和诊断。系统在不打扰车主的情况下复检故障信息。在确定故障后，并实施远程自动消除故障",
          tedian: "高效、实时、准确、多功能",
        },
      },
      车身电子desc:
        "智能光影尾门传感器、座椅控制器、座椅按摩控制器、内外灯控制板、天窗控制器等",
      智能座舱desc: "座舱域控制器、功放、扬声器、T-BOX、AR-HUD、车载显示屏等",
      智能驾驶desc:
        "智能前视一体机、行泊一体控制器、商用车紧急制动控制器（AEBS）等",
      车联网desc:
        "eSync OTA平台、车云一体化开发平台（整合OTA、远程诊断、协议栈）",
      总专利数: "总专利数：",
      项: "项",
      发明专利: "发明专利：",
      实用新型专利: "实用新型专利：",
      外观设计专利: "外观设计专利：",
      软件著作权: "软件著作权：",
    },
    生产开发服务: "生产和研发服务",
    技术开发服务: "技术开发服务",
    生产制造: "生产制造",
    技术开发服务desc: "汽车电子控制单元（ECU）开发服务",
    生产制造desc: "贴片(SMT)和组装",
    招贤纳士: {
      招贤纳士: "招贤纳士",
      社会招聘: "社会招聘",
      校园招聘: "校园招聘",
      返回: "<<返回",
      工作职责: "工作职责",
      招聘人数: "招聘人数",
      工作地点: "工作地点",
      所属公司: "所属公司",
      岗位职责: "岗位职责",
      任职要求: "任职要求",
      投递简历请联系: "投递简历请联系",
      招聘网站链接: "招聘网站链接",
      投递简历: "投递简历",
    },
    lang: "EN",
  },
};
